// Orders tasks by due date: overdue and soonest first, tasks with no date last.
const key = (t) => {
  const d = t && t.dueDate ? String(t.dueDate).slice(0, 10) : '';
  return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : '9999-99-99';
};
export const compareByDueDate = (a, b) => (key(a) < key(b) ? -1 : key(a) > key(b) ? 1 : 0);
export const sortByDueDate = (tasks) => [...(tasks || [])].sort(compareByDueDate);
